// removed by extract-text-webpack-plugin
module.exports = {"base":"Paginator_base--3JdXf","control":"Paginator_control--206Oo","isDisabled":"Paginator_isDisabled--KyXcL","control__prev":"Paginator_control__prev--jsk7_","controlPrev":"Paginator_control__prev--jsk7_","control__next":"Paginator_control__next--1SWEU","controlNext":"Paginator_control__next--1SWEU","current":"Paginator_current--3Xut3","divider":"Paginator_divider--36nXv","total":"Paginator_total--nOshA"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Paginator/Paginator.scss
// module id = 2272
// module chunks = 11